export interface IFilter {
  id: number;
  data: object;
  children: IFilter[];
  parentId: number | null;
  orderIdx: number;
}

export class Filter {
  id: number;
  data: object;
  children: Filter[];
  parentId: number | null;
  orderIdx: number;

  constructor(filter: IFilter) {
    this.id = filter.id;
    this.data = filter.data;
    this.children = filter.children;
    this.parentId = filter.parentId;
    this.orderIdx = filter.orderIdx;
  }
}

export function getAllChildren(filters: Filter[]): Filter[] {
  var children: Filter[] = [];
  filters.forEach((f) => _recurse(f, children));
  return children;
}

export function _recurse(filter: Filter, children: Filter[]) {
  if (filter.children.length > 0) {
    filter.children.forEach((f) => _recurse(f, children));
  } else {
    if (!children.find((c) => c.id == filter.id)) children.push(filter);
  }
}
